import React, {
  Fragment,
  useRef,
  useState,
  useContext,
  createContext,
  useEffect,
} from "react";
import { motion, AnimatePresence, useAnimation } from "framer-motion";
import CodeEditor from "@uiw/react-textarea-code-editor";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import loadingCircleImg from "../../../../images/misc/loading-circle-green.svg";
import landmarkImg from "../../../../images/landmark/logo-text-dark.png";
import ApiService from "../../../../services/ApiService";
import PageHeaderBar from "../../../layouts/PageHeaderBar";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import PersonIcon from "@mui/icons-material/Person";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { styled } from "@mui/material/styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { utils } from "ethers";
import { MaterialReactTable } from "material-react-table";
import { ExportToCsv } from "export-to-csv";
import { ExportJsonCsv } from "react-export-json-csv";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { FileCopyOutlined as FileCopyOutlinedIcon } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { darken } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { TypeAnimation } from "react-type-animation";
import {
  areSetsEqual,
  copyTextToClipboard,
  useDocumentTitle,
} from "../../../utils";
import { ThemeContext } from "../../../../context/ThemeContext";
import {
  addOneMonth,
  arraysAreEqual,
  epochToDateString,
  epochToDateTimeString,
  stringToRGB,
  toTitleCase,
} from "../../../../utils";
import { useAuth } from "../../../Providers/LandmarkAuthContext";
import EmployeeInfo from "./EmployeeInfo";

const MasterEventsTable = ({
  employee,
  quickbooksCustomers,
  opportunityId,
  invoiceOpportunity,
  addQuickbooksCustomerSalesforceMapping,
}) => {
  const [selectedQuickbooksCustomerName, setSelectedQuickbooksCustomerName] =
    useState("");
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const opportunityUrl = `https://landmarkventures.lightning.force.com/lightning/r/Opportunity/${opportunityId}/view`;

  const selectQuickbooksCustomer = (quickbooksCustomerName) => {
    setSelectedQuickbooksCustomerName(quickbooksCustomerName);
  };

  const confirmBtnClicked = async () => {
    if (!selectedQuickbooksCustomerName) {
      toast.error(`Please select a Quickbooks Customer`);
      return;
    } else {
      const customerId = quickbooksCustomers.find(
        (qc) => qc.displayName === selectedQuickbooksCustomerName
      ).customerId;
      const success = await addQuickbooksCustomerSalesforceMapping(
        customerId,
        invoiceOpportunity.clientName
      );
      if (success) {
        // show success msg
        setShowSuccessMsg(true);
      }
    }
  };

  if (!quickbooksCustomers || !quickbooksCustomers.length) {
    return (
      <div className="error-msg">
        Could not get Quickbooks Customers from server (if this problem persists
        please notify{" "}
        <a href="mailto:mjones@landmarkventures.com">
          mjones@landmarkventures.com
        </a>
        )
      </div>
    );
  }

  if (!opportunityId || !opportunityId.length) {
    return <div className="error-msg">Opportunity ID missing from URL</div>;
  }

  if (!invoiceOpportunity) {
    return (
      <div className="error-msg">
        Could not get Invoice Opportunity from server (if this problem persists
        please notify{" "}
        <a href="mailto:mjones@landmarkventures.com">
          mjones@landmarkventures.com
        </a>
        )
      </div>
    );
  }

  return (
    <>
      <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
        <Card className="mb-3 h-fc bot-table">
          {/* <div className="event-image-img">
              <img src={selectedInvoice.imageUrl} className="img-fluid" />
            </div> */}
          <div className="row">
            <div className="outputHeader">Set Quickbooks Customer</div>
            <>
              <></>
              <div className="outputBody">
                <div className="table-wrapper">
                  {
                    <div className="text-center mb-3">
                      <div className="qb-settings">
                        <div className="qb-settings-group">
                          <label className="form-label">
                            <span className="example-text">
                              In Salesforce, the{` `}
                              <a
                                target={"_blank"}
                                className="inv-link"
                                href={opportunityUrl}
                              >
                                opportunity
                              </a>
                              {` `}client is{` `}
                              <span className="client-name">
                                {invoiceOpportunity.clientName}
                              </span>
                            </span>
                            <br />
                            <div className="example-text">
                              <b>
                                Please select the corresponding Quickbooks
                                Customer:
                              </b>
                            </div>
                          </label>
                          {showSuccessMsg ? (
                            <>
                              <div className="error-msg thank-you-msg">
                                Thank you!
                              </div>
                            </>
                          ) : (
                            <div className="qb-customer-select-container">
                              <select
                                defaultValue={"All"}
                                className="quickbooks-select"
                                onChange={(e) =>
                                  selectQuickbooksCustomer(e.target.value)
                                }
                                value={selectedQuickbooksCustomerName}
                              >
                                <option>{``}</option>
                                {quickbooksCustomers.map((c) => (
                                  <option>{c.displayName}</option>
                                ))}
                              </select>
                              <button
                                className={`create-event-btn btn btn-sm btn-primary email-options-btn`}
                                onClick={confirmBtnClicked}
                              >
                                {`Confirm`}
                                {/* <i className="event-owner-add fa-sharp fa-solid fa-user ml-05"></i> */}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </>
          </div>
        </Card>
      </motion.div>
    </>
  );
};

const getQueryParams = (search) => {
  return new URLSearchParams(search);
};

const Dashboard = (props) => {
  const { changeBackground } = useContext(ThemeContext);
  const { employee, isAuthenticated, loading, logout } = useAuth();

  const [invoiceOpportunity, setInvoiceOpportunity] = useState(null);
  const [quickbooksCustomers, setQuickbooksCustomers] = useState([]);

  const query = getQueryParams(window.location.search);
  const opportunityId = query.get("opportunity");

  // set light theme once
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // touch lastSeenTime when authenticated (fire & forget)
  useEffect(() => {
    if (!isAuthenticated || !employee) return;
    try {
      const api = new ApiService({ employee });
      api.get("landmark/employees/login");
    } catch {
      /* noop */
    }
  }, [isAuthenticated, employee]);

  async function getQuickbooksCustomers() {
    try {
      const api = new ApiService({ employee });
      const response = await api.get(
        `landmark/invoicemanager/getQuickbooksCustomers`
      );
      setQuickbooksCustomers(response);
    } catch (error) {
      console.error(error);
    }
  }

  async function getInvoiceOpportunity() {
    if (opportunityId && opportunityId.length) {
      try {
        const api = new ApiService({ employee });
        const response = await api.get(
          `landmark/invoicemanager/getInvoiceOpportunity/${opportunityId}`
        );
        setInvoiceOpportunity(response);
      } catch (error) {
        console.error(error);
      }
    }
  }

  // load data after auth
  useEffect(() => {
    if (isAuthenticated) {
      getQuickbooksCustomers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (opportunityId && isAuthenticated) {
      getInvoiceOpportunity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opportunityId, isAuthenticated]);

  async function addQuickbooksCustomerSalesforceMapping(customerId, salesforceMapping) {
    try {
      const api = new ApiService({ employee });
      const { success, error } = await api.post(
        `landmark/invoicemanager/addQuickbooksCustomerSalesforceMapping`,
        { customerId, salesforceMapping }
      );
      if (!success) {
        toast.error(`${error}`);
        return false;
      } else {
        toast.success(`${success}`);
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  }

  useDocumentTitle("Invoice Customer Dashboard - Landmark Ventures");

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border" role="status" aria-label="Loading" />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="global-dash-wrapper invoice-dash">
        <div className="d-flex align-items-center justify-content-center">
          <img src={landmarkImg} className="img-fluid landmark-img" alt="Landmark" />
        </div>

        {isAuthenticated && employee && (
          <div className="landmark-sign-in" style={{ marginBottom: "18px" }}>
            <div className="existing-accounts-container">
              <EmployeeInfo
                landmarkEmployee={employee}
                disableHover={true}
                showLogout={true}
                logout={logout}
              />
            </div>
          </div>
        )}

        <PageHeaderBar
          pages={[
            { title: "Landmark", url: `` },
            {
              title: "Invoice Customer Dashboard",
              url: `/landmark/invoicecustomer/dashboard`,
            },
          ]}
        />

        {isAuthenticated ? (
          <>
            <MasterEventsTable
              employee={employee}
              quickbooksCustomers={quickbooksCustomers}
              opportunityId={opportunityId}
              invoiceOpportunity={invoiceOpportunity}
              addQuickbooksCustomerSalesforceMapping={
                addQuickbooksCustomerSalesforceMapping
              }
            />
          </>
        ) : (
          <div className="text-center text-muted p-5">
            Please sign in to access the dashboard.
          </div>
        )}
      </div>
    </Fragment>
  );
};


export default Dashboard;
